import { modalRenderer } from '~/modal/modalRendererRegistry';
import {
  TrialExportNoticeModal, type TrialExportNoticeModalProps,
} from './trialExportNoticeModal.component';

declare module '~/modal/modalRegistry.type' {
  interface ModalComponentRegistry {
    TrialExportNotice: TrialExportNoticeModalProps;
  }
}

modalRenderer.register('TrialExportNotice', TrialExportNoticeModal);
